import {
  formatDirectXDisplay,
  formatHardwareDisplay,
  formatOsDisplay,
  formatStorageDisplay,
  hasSystemRequirementData,
} from '../dashboard/ADMIN/components/systemRequirementHelper'

const SystemRequirementColumn = ({ title, requirement, osOptions }) => {
  if (!hasSystemRequirementData(requirement)) return null

  const os = formatOsDisplay(requirement.os, osOptions)
  const directX = formatDirectXDisplay(requirement.directX)
  const cpu = formatHardwareDisplay(
    requirement.cpuHardwareTitles,
    requirement.cpuHardwareTitle,
    requirement.cpuHardwareIds,
    requirement.cpuHardwareId
  )
  const gpu = formatHardwareDisplay(
    requirement.gpuHardwareTitles,
    requirement.gpuHardwareTitle,
    requirement.gpuHardwareIds,
    requirement.gpuHardwareId
  )
  const vRam = formatStorageDisplay(requirement.vRam)
  const ram = formatStorageDisplay(requirement.ram)
  const storage = formatStorageDisplay(requirement.storage)

  return (
    <div className="systemRequirementDisplay__column">
      <h6 className="systemRequirementDisplay__title">{title}</h6>
      <div className="systemRequirementDisplay__body" dir="ltr">
        {requirement.x32 && <div>x32</div>}
        {requirement.x64 && <div>x64</div>}
        {requirement.requirement?.trim() && (
          <div>
            <span>Requirement : </span>
            {requirement.requirement}
          </div>
        )}
        {os && (
          <div>
            <span>OS : </span>
            {os}
          </div>
        )}
        {cpu && (
          <div>
            <span>CPU : </span>
            {cpu}
          </div>
        )}
        {gpu && (
          <div>
            <span>GPU : </span>
            {gpu}
          </div>
        )}
        {vRam && (
          <div>
            <span>VRam : </span>
            {vRam}
          </div>
        )}
        {ram && (
          <div>
            <span>RAM : </span>
            {ram}
          </div>
        )}
        {storage && (
          <div>
            <span>Storage : </span>
            {storage}
          </div>
        )}
        {directX && (
          <div>
            <span>Direct X : </span>
            {directX}
          </div>
        )}
      </div>
    </div>
  )
}

const SystemRequirementDisplay = ({
  minimumSystemRequirement,
  recommendedSystemRequirement,
  osOptions = [],
}) => {
  const showMinimum = hasSystemRequirementData(minimumSystemRequirement)
  const showRecommended = hasSystemRequirementData(recommendedSystemRequirement)

  if (!showMinimum && !showRecommended) return null

  return (
    <>
      <br />
      <div className="systemRequirementDisplay">
        {showMinimum && (
          <SystemRequirementColumn
            title="حداقل سیستم مورد نیاز"
            requirement={minimumSystemRequirement}
            osOptions={osOptions}
          />
        )}
        {showRecommended && (
          <SystemRequirementColumn
            title="سیستم مورد نیاز پیشنهادی"
            requirement={recommendedSystemRequirement}
            osOptions={osOptions}
          />
        )}
      </div>
    </>
  )
}

export default SystemRequirementDisplay
